module.exports = __webpack_public_path__ + "static/media/priceImage1.0a63b9fc.svg";